import { createFileRoute } from '@tanstack/react-router';
import { DeviceAssignmentTab } from '@/features/devices/components';

export const Route = createFileRoute('/_app/devices/$deviceId/assignment')({
  component: DeviceAssignmentTab,
});
